module.exports = __webpack_public_path__ + "images/social/auto-ship-e029aea1.jpg";